import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Packages
import { Helmet } from 'react-helmet'

// Actions
import {
  getProfileAccountDetails
} from '../../../actions/accountDetails'

// Actions
import {
  updateActiveProfile
} from '../../../actions/activeProfile'

import {
  updateUserState
} from '../../../actions/user'

// Components
import Header from '../../../components/Global/Header'
import Footer from '../../../components/Global/Footer'
import AccountSettingsNav from '../../../components/UserPortal/AccountSettings/AccountSettingsNav'
import FormContainer from '../../../components/Global/FormContainer'
import AthleteInfoForm from '../../../components/Forms/AthleteInfoForm'
import FlashMessage from '../../../components/Global/FlashMessage'

class AthleteInfo extends Component {

  state = {
    displayFlashMessage: false
  }

  componentDidMount() {
    const { user, activeProfile } = this.props

    this.props.getProfileAccountDetails(user, activeProfile.username)
  }

  handleFormSubmit = (profile) => {
    const { user, activeProfile } = this.props

    let updatedProfile = Object.assign(activeProfile, profile)

    this.props.updateActiveProfile(user, activeProfile.username, updatedProfile)
    .then(response => {
      this.updateUserMaintainedProfiles(user, activeProfile, updatedProfile)
      this.handleSuccessfulSubmit()
    })
  }

  updateUserMaintainedProfiles(user, activeProfile, profile) {
    let updatedUser = {...user}
    let maintainedProfiles = [...user.maintained_profiles]

    let updateIndex = maintainedProfiles.findIndex((profile) => {
      return profile.username === activeProfile.username
    })

    let updatedMaintainedProfile = {
      first_name: profile.first_name,
      last_name: profile.last_name,
      username: activeProfile.username
    }

    let newMaintainedProfileState = [
      ...maintainedProfiles.slice( 0, updateIndex ),
      updatedMaintainedProfile,
      ...maintainedProfiles.slice( updateIndex + 1, maintainedProfiles.length)
    ]

    updatedUser.maintained_profiles = newMaintainedProfileState

    this.props.updateReduxUser(updatedUser)
  }

  handleSuccessfulSubmit() {
    window.scrollTo(0, 0)
    this.setState({
      displayFlashMessage: true
    })
  }

  renderSuccessFlashMessage() {
    const { displayFlashMessage } = this.state

    return displayFlashMessage
    ? (
      <FlashMessage>
        Your changes have been saved successfully.
      </FlashMessage>
    ) : null
  }

  render() {
    const { path, appName } = this.props

    return (
      <div className="user-portal account-settings">
        <Helmet>
          <title>{appName} | Settings: Athlete Info</title>
        </Helmet>
        <Header path={ path } />
        <AccountSettingsNav currentTab="athlete-info" />
        <FormContainer>
          <header>
            <h1>Athlete Info</h1>
            <p className="note">
              This screen allows you to edit all of your global athlete information. Regardless of sport, this information will serve as the basis of your profile, and is an overview of you as an athlete. This information is displayed publicly on your profile. To edit sport specifics,  <Link to="/locker">visit your locker</Link>.
            </p>
          </header>
          {this.renderSuccessFlashMessage()}
          <AthleteInfoForm
            showUsernameInput={false}
            handleSubmit={(input) => this.handleFormSubmit(input)}
            submitButtonText="Save Changes"
            formLocation="settings"
          />
        </FormContainer>
        <Footer appName={ appName } path={ path } />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    activeProfile: state.activeProfile
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getProfileAccountDetails: (user, profileUsername) => {
      dispatch(getProfileAccountDetails(user, profileUsername))
    },
    updateActiveProfile: (user, username, profile) => dispatch(updateActiveProfile(user, username, profile)),
    updateReduxUser: (user) => dispatch(updateUserState(user))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AthleteInfo)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Settings/AthleteInfo.js